module.exports = __webpack_public_path__ + "img/16.0a0a2731.jpeg";